import { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { PollToggleIcon } from '../../../atoms/PollToggleIcon';

interface Props {
    onClick: MouseEventHandler<HTMLButtonElement>;
    shown: boolean;
    /** Id of the poll content this button shows and hides. */
    contentId: string;
}
export const SSPollToggleButton = ({ onClick, shown, contentId }: Props) => {
    const { t } = useTranslation();

    return (
        <button
            type="button"
            className={`group absolute top-2 right-0 rounded-l-lg flex items-center py-3 ${shown ? 'bg-transparent hover:bg-primary pl-3 pr-6' : 'bg-primary shadow-md pr-3 pl-6'} pointer-events-auto z-50`}
            onClick={onClick}
            aria-expanded={shown}
            aria-controls={contentId}
            data-testid="PollToggleButton"
        >
            <span className="sr-only">{t('Player.Button.Poll')}</span>
            <PollToggleIcon shown={shown} />
        </button>
    );
};
